export const COLORS = {
    PRIMARY: "#EE1D52",
    BACKGROUND: "#F6F6F6"
}
